import $ from 'jquery';
// Hamburger toggle
$('#navbar-toggle').on('click', function() {
    this.classList.toggle('active');
    $('.cwm-nav').slideToggle();
    $('.cwm-navbar-right .cwm-dropdown-content').hide("slow");
  });
  
  $(function() {
    if($('.cwm-enquiry-ribbon').length > 0) {
      $('.default-nav').addClass('nav-margin-top');
    }
  });
  $(function() {
    $('.cwm-navbar-right .cwm-dropdown').each().on('focus', '.cwm-navbar-right .cwm-dropdown-content a', function() {   
      $(this).closest('.cwm-dropdown').addClass('focus');
    }).on('blur', '.cwm-navbar-right .cwm-dropdown-content a', function() {
      $(this).closest('.cwm-dropdown').removeClass('focus');
    });
  });

if($(window).width() < 1025) {
    $(' ul.cwm-nav li.cwm-dropdown button.icon-right-ar:not(:only-child)').click(function(e) {
        $(this).siblings('.cwm-nav .cwm-dropdown-content').slideToggle("slow");
        $(this).siblings('.cwm-nav .cwm-dropdown-content').parent('.cwm-dropdown').toggleClass('active');
        // Close dropdown when select another dropdown
        $('.cwm-nav .cwm-dropdown-content').not($(this).siblings()).hide("slow");
        $('.cwm-nav .cwm-dropdown-content').not($(this).siblings()).parent('.cwm-dropdown').removeClass("active");
        e.stopPropagation();
      });
	$(' ul.cwm-navbar-right li.cwm-dropdown a:not(:only-child)').click(function(e) {
      $(this).siblings('.cwm-navbar-right .cwm-dropdown-content').slideToggle("slow");
      $('.cwm-nav').hide(200);
      $('#navbar-toggle').removeClass("active");
      // Close dropdown when select another dropdown
      $('.cwm-navbar-right .cwm-dropdown-content').not($(this).siblings()).hide("slow");
      e.stopPropagation();
    });
   
}
if($(window).width() > 1025) {
    $(window).scroll(function() {
      if ($(this).scrollTop() > 40) {
        $('.default-nav').addClass('default-nav-sticky'); 
      }
      else{
        $('.default-nav').removeClass('default-nav-sticky'); 
      }
    });
}


// WEBPACK FOOTER //
// ./components/cwm-header/scripts/cwm-header.js